import { DesktopView } from './components/MarcomNavBar';
export { useAppNavBar } from './useMarcomAppNavBar';
export { SeoHeaderLinks } from './components/SeoHeaderLinks';

export const MarcomAppNavBar = DesktopView;
